import { Icon, OptionType } from "shared";
import React from "react";
import styles from "./tag_item.module.scss";

interface ITagItemProps {
    option: OptionType;
    onRemove: (value: string) => void;
}

export const TagItem: React.FC<ITagItemProps> = React.memo(({ option, onRemove }) => {
    return <div className={styles.itemBlock}>
        <div>{option.tagLabel ? option.tagLabel : option.label}</div>
        <div className={styles.deleteIcon} onClick={() => onRemove(option.value)}>
            <Icon glyph="close" size="s"></Icon>
        </div>
    </div>
})
